export default "__VITE_ASSET__exJ7SS0k__"